import { AppField, Preferences, Tag } from "@smartsuite/types";
import { GridViewAggregationRenderer } from "@smartsuite/gridview/lib/components/GridView/GridView.types";
import { GridViewFieldRenderer } from "@smartsuite/gridview/lib/components/GridViewCell/GridViewCell.types";
import { GridViewGroupFieldRenderer } from "@smartsuite/gridview/lib/components/GridViewGroup/GridViewGroup.types";
import { FieldParametersFormRenderer } from "@smartsuite/gridview/lib/components/GridView/components/FieldParametersForm/FieldParametersForm.types";
import { getFieldSlug } from "@smartsuite/fields-logic/lib/utils/fields";
import { Text } from "@smartsuite/react-ui/lib";
import React from "react";

import { BaseRecord } from "../../../../../../types/form";
import { getDisplayValue } from "../../../display-value/getFieldDisplayValue";

interface CreateGridViewFieldRendererDeps {
  fieldsToShow: Record<string, AppField>;
  tags?: Tag[];
  relatedRecords?: BaseRecord[];
  userPreferences?: Preferences;
}

export const createGridViewFieldRenderer = ({
  fieldsToShow,
  tags,
  relatedRecords,
  userPreferences,
}: CreateGridViewFieldRendererDeps): GridViewFieldRenderer => {
  const GridViewFieldRendererComponent: GridViewFieldRenderer = ({ field, record }) => {
    const fieldSlug = getFieldSlug(field);
    const displayValue = getDisplayValue(
      record,
      fieldSlug,
      fieldsToShow,
      tags,
      relatedRecords,
      undefined,
      userPreferences
    );

    return (
      <Text size="l" wrapMode="ellipsis" className="form-field-value">
        {displayValue}
      </Text>
    );
  };

  return GridViewFieldRendererComponent;
};

export const gridViewGroupRenderer: GridViewGroupFieldRenderer = () => <></>;

export const gridViewAggregationRenderer: GridViewAggregationRenderer = () => <></>;

export const fieldParametersFormRenderer: FieldParametersFormRenderer = () => <></>;
